import { narrateStimulus, resetQuestionsAndTimeTrackingState, selectPossibleResponse } from './questionsActions';
import selectors from '../../rootSelectors';
import { narrateReset, stopAudio } from '../audio/audioActions';
import { activateNextButton, unmountScreen } from '../screen/screenActions';
import { GENERAL_AUDIO_DELAY } from '../../constants/time';

export const mapStateToProps = (state) => ({
    selectedIndex: selectors.getSelectedIndex(state),
    isNextButtonVisible: selectors.getIsNextButtonActive(state),
    isStimulusPlaying: selectors.getIsStimulusPlaying(state),
    isScreenBlocked: selectors.getIsScreenBlocked(state),
    isGreyedOut: selectors.getIsScreenGreyedOut(state),
    isReadyForNextScreen: selectors.getQuestionsIsReadyForNextScreen(state),
});

export const mapDispatchToProps = (dispatch) => ({
    cleanup: () => {
        dispatch(stopAudio());
        dispatch(narrateReset());
        dispatch(resetQuestionsAndTimeTrackingState());
        dispatch(unmountScreen());
    },
    selectResponse: (index) => {
        dispatch(selectPossibleResponse(index));
        dispatch(activateNextButton());
    },
    narrateStimulus: (stimulusAudio, delay = GENERAL_AUDIO_DELAY) => {
        dispatch(narrateStimulus(stimulusAudio, delay));
    },
    narrateScreen: (stimulusAudio, delay = GENERAL_AUDIO_DELAY) => {
        dispatch(narrateStimulus(stimulusAudio, delay));
    },
});
